if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        if (this.prevButton) {
          this.prevButton.addEventListener('pointerup', (event) => event.stopPropagation());
          this.prevButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.showPreviousMedia();
          });
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('pointerup', (event) => event.stopPropagation());
          this.nextButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.showNextMedia();
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      showNextMedia() {
        const items = this.getMediaItems();
        const currentIndex = items.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (currentIndex + 1) % items.length;
        this.setActiveMediaElement(items[nextIndex]);
      }

      showPreviousMedia() {
        const items = this.getMediaItems();
        const currentIndex = items.findIndex((item) => item.classList.contains('active'));
        const previousIndex = (currentIndex - 1 + items.length) % items.length;
        this.setActiveMediaElement(items[previousIndex]);
      }

      setActiveMediaElement(activeMedia) {
        if (!activeMedia) return;
        this.getMediaItems().forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActiveMediaElement(activeMedia);
      }
    }
  );
}
